// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.2.0",
  date: "2026-06-29T08:04:38.800Z",
  gitInfo: {
    dirty: false,
    raw: "dbdb179db",
    hash: "dbdb179db",
    distance: null,
    tag: null,
    semver: null,
    suffix: "dbdb179db",
    semverString: null
  }
};
/* tslint:enable */
